export enum ConcretingRequestMessages {
  stepContractText = "concretingRequest.stepContractText",
  stepConcretingText = "concretingRequest.stepConcretingText",
  stepConcreteRecipeText = "concretingRequest.stepConcreteRecipeText",
  stepPumpText = "concretingRequest.stepPumpText",
  requestNewConcretingText = "concretingRequest.addNewConcretingRequestText",
  clientWithPendencyText = "concretingRequest.clientWithPendencyText",
  messagesDialogTitle = "concretingRequest.messagesDialogTitle",
  messageUnderReview = "concretingRequest.messageUnderReview",
  contractWithPendenciesMessage = "concretingRequest.contractWithPendenciesMessage",
  inactiveContractMessage = "concretingRequest.inactiveContractMessage"
}

export interface TranslationConcretingRequestMessages {
  [ConcretingRequestMessages.stepContractText]: string;
  [ConcretingRequestMessages.stepConcretingText]: string;
  [ConcretingRequestMessages.stepConcreteRecipeText]: string;
  [ConcretingRequestMessages.stepPumpText]: string;
  [ConcretingRequestMessages.requestNewConcretingText]: string;
  [ConcretingRequestMessages.clientWithPendencyText]: string;
  [ConcretingRequestMessages.messagesDialogTitle]: string;
  [ConcretingRequestMessages.messageUnderReview]: string;
  [ConcretingRequestMessages.contractWithPendenciesMessage]: string;
  [ConcretingRequestMessages.inactiveContractMessage]: string;
}
